export const translations = {
    ko: {
        logo: "한글 놀이마당",
        brand: "K-Food 한글",
        introSub: "K-Food Hangul",
        nav: { play: "놀이마당", market: "장터마당", ranking: "순위" },
        nav_play: "놀이마당",
        play_sub1: "한글비",
        play_sub2: "문장 만들기",
        rank_title: "명예의 전당",
        rank_player: "사용자",
        rank_score: "점수",
        rank_tier: "등급",
        hero_title: "한글 놀이마당",
        hero_desc: "K-Food를 통해 한글을 익혀 보십시오.",
        hero: { title: "한글 놀이마당", subtitle: "K-Culture를 즐기다", desc: "K-Food를 통해 한글을 익혀 보십시오." },
        auth: { login: "로그인", signup: "회원가입" },
        tier_1: "입문", tier_2: "초보", tier_3: "중수",
        tier_4: "숙련", tier_5: "전문", tier_6: "대가",
        no_data: "표시할 데이터가 없습니다.", no_msg: "새로운 메시지가 없습니다."
    },
    en: {
        logo: "Hangeul Playground",
        brand: "K-Food Hangul",
        introSub: "K-Food Hangul",
        nav: { play: "Playground", market: "Market", ranking: "RANKINGS" },
        nav_play: "Playground",
        play_sub1: "Word Rain",
        play_sub2: "Sentence Maker",
        rank_title: "Leaderboard",
        rank_player: "Player",
        rank_score: "Score",
        rank_tier: "Tier",
        hero_title: "Hangeul Playground",
        hero_desc: "Master the essence of Hangeul through K-Pop, K-Drama, K-Food, and K-Culture.",
        hero: { title: "Hangeul Playground", subtitle: "Enjoy K-Culture", desc: "Master the essence of Hangeul through K-Pop, K-Drama, K-Food, and K-Culture." },
        auth: { login: "Log In", signup: "Sign Up" },
        tier_1: "Novice", tier_2: "Beginner", tier_3: "Skilled",
        tier_4: "Expert", tier_5: "Master", tier_6: "Grandmaster",
        no_data: "No data to display.", no_msg: "No new messages."
    },
    jp: {
        logo: "ハングル遊び場",
        brand: "K-Food ハングル",
        nav: { play: "遊び場", market: "市場", ranking: "ランキング" },
        nav_play: "遊び場",
        play_sub1: "ハングルの雨",
        play_sub2: "文章を作る",
        rank_title: "名誉の殿堂",
        rank_player: "ユーザー",
        rank_score: "スコア",
        rank_tier: "ティア",
        hero_title: "ハングル遊び場",
        hero_desc: "K-Pop、K-Drama、K-Food、K-Cultureの精髄を通じてハングルの本質を貫いてください。",
        hero: { title: "ハングル遊び場", subtitle: "K-Cultureを楽しむ", desc: "K-Pop、K-Drama、K-Food、K-Cultureの精髄を通じてハングルの本質を貫いてください。" },
        auth: { login: "ログイン", signup: "新規登録" },
        tier_1: "入門", tier_2: "初心者", tier_3: "中級者",
        tier_4: "熟練者", tier_5: "専門家", tier_6: "達人",
        no_data: "表示するデータがありません。", no_msg: "新しいメッセージはありません."
    },
    es: {
        logo: "Patio de Hangeul",
        brand: "K-Food Hangul",
        nav: { play: "Patio", market: "Mercado", ranking: "Clasificación" },
        nav_play: "Patio",
        play_sub1: "Lluvia de Palabras",
        play_sub2: "Creador de Oraciones",
        rank_title: "Salón de la Fama",
        rank_player: "Jugador",
        rank_score: "Puntuación",
        rank_tier: "Nivel",
        hero_title: "Patio de juegos de Hangeul",
        hero_desc: "Domina la esencia del Hangeul a través del K-Pop, K-Drama, K-Food y K-Culture.",
        hero: { title: "Patio de juegos de Hangeul", subtitle: "Disfruta de la K-Culture", desc: "Domina la esencia del Hangeul a través del K-Pop, K-Drama, K-Food y K-Culture." },
        auth: { login: "Acceder", signup: "Registro" },
        tier_1: "Novato", tier_2: "Principiante", tier_3: "Intermedio",
        tier_4: "Experto", tier_5: "Profesional", tier_6: "Gran Maestro",
        no_data: "No hay datos para mostrar.", no_msg: "No hay mensajes nuevos."
    }
};
